/**
 * Constantes para el módulo de estadísticas
 * No incluye estilos según las reglas de refactorización
 */

/**
 * Tipos de reportes disponibles
 */
export const REPORT_TYPES = [
  { value: 'fees_by_order', label: 'Cuotas por órden' },
  { value: 'deferred_coupons', label: 'Cupones diferidos' },
  { value: 'issued_coupons', label: 'Cupones emitidos' },
  { value: 'coupon_details_fer', label: 'Detalle cupones (Fer)' },
  { value: 'score_ranking', label: 'Ranking de puntajes' },
  { value: 'debt_balances', label: 'Saldos de deuda' },
  { value: 'sales', label: 'Ventas' },
  { value: 'subscribers', label: 'Suscriptores' },
];

/**
 * Filtros iniciales del formulario
 */
export const INITIAL_FILTERS = {
  dateStart: '',
  dateEnd: '',
  reportType: 'not_selected',
  whitHouse: 'not_selected',
  branch: '',
  plan: 'all',
  group: 'all',
  orderNumber: '',
  detail: false,
  deferred: false,
  historical: false,
  cuota_pura: '',
  legalEntity: 'all',
};

/**
 * Configuración de paginación para las tablas
 */
export const PAGINATION_CONFIG = {
  DEFAULT_ROWS_PER_PAGE: 200,
  ROWS_PER_PAGE_OPTIONS: [100, 200, 500],
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  ERROR: {
    FETCH_DATA: 'Error al obtener los datos.',
    PDF_TOO_LARGE: 'Este reporte es demasiado extenso y no se encuentra disponible en formato PDF.',
  },
  SUCCESS: {
    EXPORT_EXCEL: 'Archivo Excel descargado exitosamente',
    EXPORT_PDF: 'Archivo PDF generado exitosamente',
  },
};

/**
 * Configuración de exportación
 */
export const EXPORT_CONFIG = {
  EXCEL_FILENAME_PREFIX: {
    fees_by_order: 'CuotasPorOrden',
    deferred_coupons: 'CuponesDiferidos',
    issued_coupons: 'CuponesEmitidos',
    coupon_details_fer: 'DetalleCuponesFer',
    score_ranking: 'RankingDePuntajes',
    sales: 'ReporteVentas',
    debt_balances: 'SaldosDeDeuda',
    subscribers: 'ReporteSuscriptores',
  },
  PDF_CONFIG: {
    orientation: 'portrait', // o 'landscape' según el reporte
    fontSize: {
      title: 12,
      header: 10,
      content: 9,
    },
  },
};
